import { timeline } from '@/mocks/home';

export default function Timeline() {
  return (
    <section id="timeline" className="w-full bg-foreground-950 py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
          <div className="lg:col-span-4">
            <div className="lg:sticky lg:top-28">
              <span className="inline-flex items-center gap-2 text-xs font-label tracking-[0.24em] text-accent-400">
                <span className="w-6 h-px bg-accent-500" />
                TIMELINE
              </span>
              <h2 className="mt-4 font-heading font-black text-background-50 text-3xl md:text-4xl tracking-tight leading-snug">
                详细经过
                <br />
                一条可回查的时间线
              </h2>
              <p className="mt-5 text-sm md:text-base leading-relaxed text-background-300/75">
                从第一次进入视野到冷处理阶段，共 8 个节点。标记为关键的四处，
                是灵灵黑料完整版里最容易被忽略、却最影响理解的部分。
              </p>
              <div className="mt-8 flex items-center gap-5">
                <div className="flex items-center gap-2">
                  <span className="w-2.5 h-2.5 rounded-full bg-accent-500" />
                  <span className="text-xs font-label text-background-300/75">关键节点 4</span>
                </div>
                <div className="flex items-center gap-2">
                  <span className="w-2.5 h-2.5 rounded-full bg-background-600" />
                  <span className="text-xs font-label text-background-300/75">常规节点 4</span>
                </div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-8">
            <ol className="relative border-l border-background-800 pl-6 md:pl-8">
              {timeline.map((item) => {
                const key = item.level === 'key';
                return (
                  <li key={item.id} className="relative pb-9 last:pb-0">
                    <span
                      className={`absolute -left-[31px] md:-left-[39px] top-1.5 w-3.5 h-3.5 rounded-full border-2 ${
                        key
                          ? 'bg-accent-500 border-accent-500'
                          : 'bg-foreground-950 border-background-600'
                      }`}
                    />
                    <div className="flex flex-wrap items-center gap-3">
                      <span
                        className={`font-heading font-black text-lg md:text-xl ${
                          key ? 'text-accent-400' : 'text-background-200'
                        }`}
                      >
                        {item.time}
                      </span>
                      {key && (
                        <span className="px-2 py-0.5 rounded-full bg-accent-500/15 text-accent-400 text-[11px] font-label border border-accent-500/30">
                          关键
                        </span>
                      )}
                    </div>
                    <h3 className="mt-2.5 font-heading font-bold text-background-50 text-base md:text-lg">
                      {item.title}
                    </h3>
                    <p className="mt-2 text-sm leading-relaxed text-background-300/70">{item.desc}</p>
                  </li>
                );
              })}
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
}